import { FormItem } from '../../../../commons/Form/Form.types';
import { LoginPUBFormSchema } from './LoginPUBForm.types';

export const loginCommercialFormData: FormItem<LoginPUBFormSchema>[][] = [
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'password',
      placeholder: 'Votre mot de passe...',
      label: 'Mot de passe',
      type: 'password',
      required: true,
    },
  ],
];
